/**
 * @param {object|null|undefined} offer
 * @returns {import("../types").FlightSegmentViewModel[]}
 */
export function mapFlightSegmentViewModels(offer) {
  const rows = Array.isArray(offer?.cardLegRows) ? offer.cardLegRows : [];
  if (rows.length) {
    return rows.map((row, i) => ({
      id: strOrNull(row.id) || `seg-${i}`,
      direction:
        strOrNull(row.direction) ||
        directionFromLabel(row.labelHe) ||
        (i === 0 ? "outbound" : i === 1 ? "inbound" : null),
      originCode: strOrNull(row.originCode || row.from || row.depAirport) || null,
      destinationCode:
        strOrNull(row.destinationCode || row.to || row.arrAirport) || null,
      departureTime: strOrNull(row.departureTime || row.depTime) || null,
      arrivalTime: strOrNull(row.arrivalTime || row.arrTime) || null,
      airlineCode: strOrNull(row.airlineCode || row.airlineId) || null,
      flightNumber: strOrNull(row.flightNumber) || null,
      durationMinutes: finiteOrNull(
        row.durationMinutes ??
          (typeof row.duration === "number" ? row.duration : null)
      ),
      durationLabel:
        typeof row.duration === "string" ? strOrNull(row.duration) : null,
      stopCount: finiteOrNull(
        row.stopCount ??
          row.stops ??
          (row.isDirect === true ? 0 : row.isDirect === false ? null : null)
      ),
      stopsLabel: strOrNull(row.stopLabelHe) || null,
      operatingCarrier:
        strOrNull(row.operatingCarrier || row.operatedBy || row.operatingAirline) ||
        null,
      cabin: strOrNull(row.cabin || row.cabinClass) || null,
      aircraft: strOrNull(row.aircraft || row.aircraftName) || null,
      departureAirport:
        strOrNull(row.departureAirport || row.originCode || row.from) || null,
      arrivalAirport:
        strOrNull(row.arrivalAirport || row.destinationCode || row.to) || null,
      departureDate:
        strOrNull(row.depDateDisplay || row.depDate || row.date) || null,
    }));
  }

  const meta = offer?.cardMeta;
  if (meta && (meta.originCode || meta.destinationCode)) {
    return [
      {
        id: "seg-0",
        direction: "outbound",
        originCode: strOrNull(meta.originCode),
        destinationCode: strOrNull(meta.destinationCode),
        departureTime: strOrNull(meta.departureTime),
        arrivalTime: strOrNull(meta.arrivalTime),
        airlineCode: strOrNull(meta.airlineCode),
        flightNumber: strOrNull(meta.flightNumber),
        durationMinutes: finiteOrNull(meta.duration),
        stopCount: meta.isDirect === true ? 0 : finiteOrNull(meta.legCount),
      },
    ];
  }

  return [];
}

function finiteOrNull(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function strOrNull(v) {
  if (v == null) return null;
  const s = String(v).trim();
  return s || null;
}

function directionFromLabel(labelHe) {
  const s = String(labelHe || "");
  if (/חזור|חזרה|return|inbound/i.test(s)) return "inbound";
  if (/הלוך|יציאה|outbound/i.test(s)) return "outbound";
  return null;
}
